import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { ReactComponent as Arrow } from "../../assets/images/settings/thin-arrow.svg"
import { SETTINGS } from "../../constants/pathname"
import { checkTheme } from "../../utils/utils"


const EulaOther = () => {
    return (
        <div
            className='support-section eula-section'
            style={{ height: "90vh" }}
        >
            <div className='main' style={{margin:"24px"}}>

                <div style={{ paddingRight: "15px" }}>
                    <p style={{ textAlign: "center", marginTop: "15px", }}>
                        <strong style={{fontSize:"24px"}}>
                            END USER LICENSE AGREEMENT FOR{" "}
                            {checkTheme()
                                ? "PLATINUMCLUBNET"
                                : " PRIVATECLUBWORLD"}
                        </strong>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            This is a legally binding end user license agreement
                            (“
                        </span>
                        <strong>EULA</strong>
                        <span style={{ fontWeight: 400 }}>
                            ”) between you (“
                        </span>
                        <strong>You</strong>
                        <span style={{ fontWeight: 400 }}>
                            ”) and MobiCom America Inc, a Delaware corporation
                            located at 6010 W Spring Creek Parkway, Plano, Texas
                            75024 (“
                        </span>
                        <strong>MobiCom</strong>
                        <span style={{ fontWeight: 400 }}>” or “</span>
                        <strong>Us</strong>
                        <span style={{ fontWeight: 400 }}>” or “</span>
                        <strong>We</strong>
                        <span style={{ fontWeight: 400 }}>
                            ”) governing your use of the{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            app licensed by MobiCom.&nbsp;
                        </span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                        <strong>
                            PLEASE READ IT CAREFULLY. BY CLICKING “I AGREE,” OR
                            INSTALLING THE PRIVATECLUBWORLD APP AND/OR ANY
                            UPDATES FROM AN APP STORE OR BY STREAMING ITS
                            CONTENT FROM ANY WEB PORTAL OWNED BY MOBICOM
                            (COLLECTIVELY, THE “MOBICOM{" "}
                            {checkTheme()
                                ? "PLATINUMCLUBNET"
                                : " PRIVATECLUBWORLD"}{" "}
                            SOFTWARE”), YOU AGREE TO THE TERMS AND CONDITIONS
                            CONTAINED HEREIN.&nbsp;
                        </strong>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                        <span style={{ fontWeight: 400 }}>
                            Please note that any reference made to an “App
                            Store” shall mean Google Play, Apple App Store or
                            any other online store from which you have
                            downloaded the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software.&nbsp;
                        </span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                        <span style={{ fontWeight: 400 }}>
                            The MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software, which allows you to connect to the{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            ecosystem, may be used by members of clubs, clubs,
                            brands, corporates and their employees. By
                            downloading or streaming the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software you undertake that you i) have obtained
                            permission from your club/brand/corporate to use the
                            MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software; or ii) are authorised to agree to the
                            terms and enter this EULA on behalf of your
                            club/brand/corporate.
                        </span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                        <span style={{ fontWeight: 400 }}>
                            You may not view, access or use the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}
                            Software in any manner whatsoever if you (a) do not
                            agree to these terms, (b) are not the older of (i)
                            at least 18 years of age or (ii) legal age to form a
                            binding contract with MobiCom, or (c) are prohibited
                            from accessing or using the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}
                            Software or any of its contents, goods or services
                            by applicable law. If you are a minor i.e. below the
                            age wherein you can form a legally binding contract
                            under applicable law, you may use the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software only with the involvement of a parent or
                            guardian{" "}
                        </span>
                        <span style={{ fontWeight: 400 }}>
                            and take full responsibility for compliance with the
                            terms and conditions of this license
                        </span>
                        <span style={{ fontWeight: 400 }}>.</span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                        <span style={{ fontWeight: 400 }}>
                            This End User License Agreement was last updated on
                            July 13
                        </span>
                        <span style={{ fontWeight: 400 }}>th</span>
                        <span style={{ fontWeight: 400 }}>
                            {" "}
                            2023. It is effective between you and MobiCom as of
                            the date you first download, install or use the
                            MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}
                            Software, whichever is earliest.&nbsp;
                        </span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>&nbsp;</span>
                        <strong>
                            <strong>LICENSE</strong>
                            <strong>:&nbsp;</strong>
                        </strong>
                    </p>
                    <p>
                        &nbsp;
                        <span style={{ fontWeight: 400 }}>
                            The MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software is protected by applicable intellectual
                            property laws. MobiCom retains all title and
                            ownership in the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software.
                        </span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                        <span style={{ fontWeight: 400 }}>
                            This is a limited, non-exclusive, revocable,
                            non-transferable license to install, use, access,
                            display and run the MobiCom
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software on any mobile device that you own or
                            control, subject to the terms and conditions herein.
                            The MobiCom
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software, is licensed, not sold, to you by MobiCom
                            and we reserve all rights not expressly granted to
                            you. You own the media or device on which the
                            MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}
                            Software is recorded or stored but MobiCom and its
                            licensors (if any) retains ownership of the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software itself.
                        </span>
                        &nbsp;
                    </p>
                    <p>
                        &nbsp;
                        <strong>
                            <strong>GENERAL TERMS:&nbsp;</strong>
                        </strong>
                    </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                By using the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software, you agree that the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software may access your content; however, we
                                will only process the same in accordance with
                                our{" "}
                            </span>
                            <span style={{ fontWeight: 400 }}>
                                Privacy Policy
                            </span>
                            <span style={{ fontWeight: 400 }}> .&nbsp;</span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                Further, you agree that you will use the MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software only in accordance with our{" "}
                            </span>
                            <span style={{ fontWeight: 400 }}>
                                Terms of Use
                            </span>
                            <span style={{ fontWeight: 400 }}>
                                {" "}
                                .&nbsp; By using the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software, you accept that you have read,
                                understood and agreed to our Privacy Policy and
                                Terms of Use.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                Your use of the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software must comply with the applicable App
                                Store rules as set forth in your App Store terms
                                of use. The license granted to you for the
                                MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software is a non-transferable license to use
                                the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software on the device you own or control and as
                                permitted by the rules set forth in the App
                                Store terms of service.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                The App Store may, at any time and without
                                notice, restrict, interrupt or prevent use of
                                the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}
                                Software, or delete the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software from your devices, or require us to do
                                any of the foregoing, without entitling you to
                                any compensation from MobiCom or any third party
                                (including, but not limited to, the App Store or
                                your network connectivity provider).&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                You will comply with applicable third party
                                terms of agreement when using the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software.&nbsp;
                            </span>
                        </li>
                    </ul>
                    <p style={{ textAlign: "center" }}>&nbsp;</p>
                    <p>
                        <strong>
                            <strong>
                                PERMITTED LICENSE USES AND RESTRICTIONS
                            </strong>
                        </strong>
                    </p>
                    <p>
                        &nbsp;The MobiCom{" "}
                        {checkTheme() ? "PlatinumClubNet" : " PrivateClubWorld"}{" "}
                        Software can be accessed through supported devices. A
                        supported device is either an Apple or Android device
                        model along with relevant iOS/android software
                        version(s) that supports the MobiCom{" "}
                        {checkTheme() ? "PlatinumClubNet" : " PrivateClubWorld"}{" "}
                        Software. This EULA allows you, as an authorized user,
                        to use the MobiCom
                        {checkTheme()
                            ? "PlatinumClubNet"
                            : " PrivateClubWorld"}{" "}
                        Software on any supported device and on no other
                        devices, except as otherwise set forth herein.&nbsp;
                    </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                You will be assumed to have obtained permission
                                from the owners&nbsp;of&nbsp;devices that are
                                controlled, but not owned by you and to download
                                a copy&nbsp;of&nbsp;the MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software onto the devices. You and they may be
                                charged by your and their service providers for
                                internet access on the devices. You accept
                                responsibility in accordance with
                                the&nbsp;terms&nbsp;of&nbsp;this EULA for
                                your&nbsp;use&nbsp;of&nbsp;the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software or any service on or in relation to any
                                device, whether or not it is owned by you.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                You may not license, sell, rent, lease, assign,
                                distribute, transmit, host, outsource, disclose
                                or otherwise commercially exploit the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software or make the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software available to any third party.&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                With respect to updates to the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software that MobiCom may make available for
                                download, this EULA allows you to download such
                                MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software updates to update or restore the
                                MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software on any supported device.&nbsp;
                            </span>
                        </li>
                    </ul>
                    <span style={{ fontWeight: 400 }}>&nbsp;</span>
                    <p>
                        &nbsp;
                        <strong>
                            <strong>TERMS REQUIRED BY APPLE INC</strong>
                        </strong>
                    </p>
                    <p>
                        &nbsp;
                        <span style={{ fontWeight: 400 }}>
                            If you are using the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software on an Apple device, you agree and accept
                            the following:
                        </span>
                    </p>

                    <ol style={{ listStyleType: "lower-alpha" }}>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                This EULA is between you and MobiCom only, and
                                not with Apple Inc. (“
                            </span>
                            <strong>Apple</strong>
                            <span style={{ fontWeight: 400 }}>
                                ”). We are solely responsible for the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}
                                Software and content thereof.&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                MobiCom is solely responsible for providing any
                                maintenance and support for the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software in accordance with this EULA and any
                                applicable law and Apple has no obligation to
                                provide the same.&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                To the maximum extent permitted by applicable
                                law, Apple will have no warranty obligation
                                whatsoever with respect to the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software, and will not be liable for any claims,
                                losses, liabilities, damages, costs or expenses
                                attributable to any failure to conform to any
                                warranty. In the event of any failure of the
                                MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software to conform to any applicable warranty,
                                and your notification to Apple of the same,
                                Apple’s responsibility will extend at the
                                maximum to refund the purchase price (if any)
                                for the MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software.&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                MobiCom is solely responsible for addressing
                                claims, and Apple shall have no responsibility
                                for addressing any claims by you or any third
                                party relating to the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}
                                Software or your possession and/or use of the
                                MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software, including but not limited to product
                                liability claims, (ii) any claim that the
                                MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software fails to conform to any applicable
                                legal or regulatory requirement, or (iii) claims
                                arising under consumer protection, privacy or
                                similar legislation.&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                We, and not Apple, shall be responsible for
                                investigating, defending, settling and
                                discharging any third party infringement claims
                                that the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software, or your possession and use of the
                                MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software, infringes a third party's intellectual
                                property rights.&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                You represent and warrant that (i) the MobiCom{" "}
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}
                                Software will not be downloaded or used in, or
                                transported to, a country that is subject to a
                                U.S. Government embargo or has been designated
                                by the U.S. Government as a
                                "terrorist-supporting" country, and (ii) you are
                                not listed on any U.S. Government list of
                                prohibited or restricted parties.&nbsp;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                You acknowledge and agree that Apple, and
                                Apple’s subsidiaries, are third party
                                beneficiaries of the EULA, and that Apple will
                                have the right to enforce the EULA against you
                                as a third party beneficiary thereof.
                            </span>
                        </li>
                    </ol>
                    <p style={{ textAlign: "left" }}>
                        &nbsp;
                        <strong>
                            <strong>INTELLECTUAL PROPERTY RIGHTS</strong>
                        </strong>
                    </p>
                    <p>
                        &nbsp;
                        <span style={{ fontWeight: 400 }}>
                            You acknowledge that all intellectual property
                            rights in the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software, and all related documents and underlying
                            technology anywhere in the world belong to us and
                            that rights in the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software are licensed (not sold) to you, and that
                            you have no rights in, or to, the MobiCom
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software other than the right
                            to&nbsp;use&nbsp;each&nbsp;of&nbsp;them in
                            accordance with the&nbsp;terms&nbsp;of&nbsp;this
                            EULA.&nbsp;
                        </span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                        Except to the extent permitted by licensing terms
                        governing the use of any open-sourced components
                        included with the MobiCom
                        {checkTheme()
                            ? "PlatinumClubNet"
                            : " PrivateClubWorld"}{" "}
                        Software, you may not copy, decompile, reverse engineer,
                        disassemble, attempt to derive the source code of,
                        decrypt, modify, or create derivative works of the
                        MobiCom
                        {checkTheme()
                            ? "PlatinumClubNet"
                            : " PrivateClubWorld"}{" "}
                        Software or MobiCom{" "}
                        {checkTheme() ? "PlatinumClubNet" : " PrivateClubWorld"}{" "}
                        Software updates/upgrades, or any part thereof. Any
                        attempt to do so is a violation of the rights of MobiCom
                        and/or its licensors. You acknowledge that you have no
                        right to have access to the MobiCom
                        {checkTheme()
                            ? "PlatinumClubNet"
                            : " PrivateClubWorld"}{" "}
                        Software in source-code form. If you, directly or
                        indirectly violate this restriction, you may be subject
                        to prosecution and damages.
                    </p>
                    <p style={{ textAlign: "left" }}>
                        &nbsp;
                        <strong>
                            <strong>INDEMNITY</strong>
                        </strong>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            You will indemnify, defend and hold us harmless
                            against any claim, demand, suit or proceeding made
                            or brought against us by a third party alleging that
                            any data that you upload into the MobiCom
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software, or your use of the MobiCom
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software and any services thereto infringes or
                            misappropriates such third party’s intellectual
                            property rights or violates applicable law (a “
                        </span>
                        <strong>Claim Against MobiCom</strong>
                        <span style={{ fontWeight: 400 }}>
                            ”), and will indemnify us from any damages, fees
                            (including attorney fees), expenses and costs
                            finally awarded against us as a result of, or for
                            any amounts paid by us under a court-approved
                            settlement of, a Claim Against MobiCom
                        </span>
                    </p>
                    <p>
                        &nbsp;
                        <strong>
                            <strong>WARRANTY</strong>
                        </strong>
                    </p>
                    <p>
                        &nbsp;
                        <span style={{ fontWeight: 400 }}>
                            You expressly acknowledge and agree that use of the
                            MobiCom
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software is at your sole risk. To the maximum extent
                            permitted by applicable law, the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}
                            Software and any services performed or provided in
                            relation thereto are provided "as is" and “as
                            available,” with all faults and without warranty of
                            any kind, and MobiCom hereby disclaims all
                            warranties, guarantees and conditions with respect
                            to the MobiCom
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software and any services, either express, implied,
                            or statutory, including, but not limited to, the
                            implied warranties and/or conditions of
                            merchantability, of satisfactory quality, of fitness
                            for a particular purpose, or of accuracy. No oral or
                            written information or advice given by MobiCom or
                            its authorized representatives shall create a
                            warranty. You may have additional consumer rights
                            under the laws of your jurisdiction that MobiCom
                            cannot change.
                        </span>
                    </p>
                    <p>
                        &nbsp;
                        <strong>
                            <strong>LIMITATION OF LIABILITY</strong>
                        </strong>
                    </p>
                    <p>
                        &nbsp;
                        <span style={{ fontWeight: 400 }}>
                            To the extent permitted by applicable law, in no
                            event shall MobiCom be liable for personal injury or
                            any incidental, special, indirect or incidental, or
                            consequential damages whatsoever, including, without
                            limitation, damages for loss of profits, loss of
                            data, business interruption, or any other commercial
                            damages or losses, arising out of or related to your
                            use of or inability to use the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software, however caused, regardless of the theory
                            of liability (contract, tort, or otherwise) and even
                            if you have been advised of the possibility of such
                            damages. The limitation applies to anything related
                            to the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software and/or any services, content etc., in
                            relation to the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software, including on any third party sites or
                            programs.&nbsp;
                        </span>
                    </p>
                    <p>
                        &nbsp;
                        <strong>
                            <strong>TERM AND TERMINATION</strong>
                        </strong>
                    </p>
                    <p>
                        &nbsp;
                        <span style={{ fontWeight: 400 }}>
                            This EULA is effective until terminated by you or by
                            us. Your rights under this EULA will terminate
                            automatically if you fail to comply with any of its
                            terms. We may terminate this EULA at any time
                            without cause.&nbsp;
                        </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 400 }}>
                            On termination for any reason:
                        </span>
                    </p>
                    <ol style={{ listStyleType: "lower-alpha" }}>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                All rights granted to you under this EULA shall
                                cease;
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                You must immediately cease all activities
                                authorized by this EULA, including
                                your&nbsp;use&nbsp;of the MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software and&nbsp;any services thereto; and
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                you must immediately delete or remove the
                                MobiCom
                                {checkTheme()
                                    ? "PlatinumClubNet"
                                    : " PrivateClubWorld"}{" "}
                                Software from all devices.
                            </span>
                        </li>
                    </ol>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Termination of this EULA shall not entitle you to
                            any refund, credit, or other compensation from
                            MobiCom under this agreement or any other agreement
                            or from any third party.{" "}
                        </span>
                    </p>
                    <p>
                        <strong>
                            <strong>&nbsp;OTHER IMPORTANT&nbsp;TERMS</strong>
                        </strong>
                    </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                We may transfer our rights and obligations under
                                this EULA to another organization, but this will
                                not affect your rights or our obligations under
                                this EULA.
                            </span>
                        </li>
                        <li>
                            If we fail to insist that you perform
                            any&nbsp;of&nbsp;your obligations under this EULA,
                            or if we do not enforce our rights against you, or
                            if we delay in doing so, that will not mean that we
                            have waived our rights against you and will not mean
                            that you do not have to comply with those
                            obligations. If we do waive a default by you, we
                            will only do so in writing, and that will not mean
                            that we will automatically waive any later default
                            by you.
                        </li>
                        <li>
                            The terms of this EULA will govern any upgrades
                            provided by us, unless such an upgrade is
                            accompanied by a separate license.
                        </li>
                        <li>
                            Each&nbsp;of&nbsp;the conditions&nbsp;of&nbsp;this
                            EULA operates separately. If any court or competent
                            authority decides that any&nbsp;of&nbsp;them are
                            unlawful or unenforceable, the remaining conditions
                            will remain in full force and effect.
                        </li>
                        <li>
                            Please note that this EULA, its subject matter and
                            its formation, are governed by the laws of the state
                            of Delaware, United States of America. You agree
                            that the courts&nbsp;of&nbsp;Delaware will have
                            exclusive jurisdiction over any disputes arising out
                            of this EULA.
                        </li>
                        <li>
                            For any legal clarifications or communications
                            regarding the MobiCom{" "}
                            {checkTheme()
                                ? "PlatinumClubNet"
                                : " PrivateClubWorld"}{" "}
                            Software, please contact us at{" "}
                            <span style={{ fontWeight: 400 }}>
                                {checkTheme()
                                    ? "support@platinumclubnet.com"
                                    : "support@privateclubworld.com"}
                            </span>
                        </li>
                    </ul>
                    <p style={{ textAlign: "center" }}>
                        <br />
                        <br />
                    </p>
                </div>
            </div>
        </div>
    )
}

export default EulaOther
